export default {
    auth_details_error_title: "No pudimos cargar tu sesión",
    auth_details_error_message: "El servicio no está disponible en este momento. Inténtalo de nuevo en unos segundos.",
    auth_details_error_retry: "Reintentar",
    auth_details_error_reload: "Recargar página",
};
